const locationDe = {
	selector: {
		districtLabel: 'Bezirk',
		upazillaLabel: 'Upazila',
		bazarLabel: 'Bazar',
		districtSearchPlaceholder: 'Bezirk suchen...',
		upazillaSearchPlaceholder: 'Upazila suchen...',
		bazarSearchPlaceholder: 'Bazar suchen...'
	},
	popup: {
		title: 'Wählen Sie Ihr Gebiet',
		instruction: 'Wählen Sie Bezirk, Upazila und Bazar, um Grameen Bazar zu nutzen',
		chooseDistrict: 'Bezirk wählen',
		chooseUpazilla: 'Upazila wählen',
		chooseBazar: 'Bazar wählen',
		districtSearchPlaceholder: 'Bezirk suchen...',
		upazillaSearchPlaceholder: 'Upazila suchen...',
		bazarSearchPlaceholder: 'Bazar suchen...',
		selectedPrefix: 'Ausgewählt:',
		confirm: 'Bestätigen'
	}
};

export default locationDe;


